/**
 * Dashboard console intent colors (numeric string keys from num_intent / process_sequences).
 * Keep in sync with api/utils/constants.py INTENT_COLOR_HEX_BY_NUM_KEY
 * and pivony-web-platform DashboardData historic `intentColors`.
 */
export const DASHBOARD_INTENT_COLORS = {
  "-1": "#6E6980",
  "1": "#671D9E",
  "2": "#DE7070",
  "3": "#46ABBF",
  "4": "#0027FF",
  "5": "#CCCCCC",
  "6": "#8D6E63",
  "7": "#FF0C32",
  "8": "#D6336B",
  "33": "#0774af",
};

/** Human labels as returned by Welcome/API intent buckets (matches api intent_range_map keys). */
export const INTENT_LABEL_TO_NUM_KEY = {
  Unspecified: "-1",
  Appraisal: "1",
  Complaint: "2",
  Suggestion: "3",
  Remark: "4",
  "Marketing & Spam": "5",
  Information: "6",
  Request: "7",
  Comparison: "8",
  mixed: "33",
};

export function hexToRgba(hex, opacity) {
  const h = (hex || "#000000").replace(/^#/, "");
  if (h.length < 6) {
    return `rgba(0,0,0,${opacity})`;
  }
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${opacity})`;
}

export function resolveIntentNumKeyFromLabel(label) {
  if (label == null || label === "") {
    return "-1";
  }
  const s = String(label).trim();
  if (!s) {
    return "-1";
  }
  if (Object.prototype.hasOwnProperty.call(INTENT_LABEL_TO_NUM_KEY, s)) {
    return INTENT_LABEL_TO_NUM_KEY[s];
  }
  if (Object.prototype.hasOwnProperty.call(DASHBOARD_INTENT_COLORS, s)) {
    return s;
  }
  const lower = s.toLowerCase();
  for (const [k, v] of Object.entries(INTENT_LABEL_TO_NUM_KEY)) {
    if (String(k).toLowerCase() === lower) {
      return v;
    }
  }
  return "-1";
}

/**
 * Stacked-bar / legend color for one intent segment (alpha 0.8 matches console doughnut).
 */
export function intentLabelToStackedBarRgba(label, alpha = 0.8) {
  const k = resolveIntentNumKeyFromLabel(label);
  const hex = DASHBOARD_INTENT_COLORS[k] || DASHBOARD_INTENT_COLORS["-1"];
  return hexToRgba(hex, alpha);
}
